import { memo, ReactNode } from "react";
import classnames from "classnames";
import CheckBoxIcon from "./CheckBoxIcon";

import { ReactComponent as ArrowDownIcon } from "./icons/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "./icons/arrow-up.svg";

import styles from "./style.module.scss";

export type ListItemProps = {
  sorting?: boolean,
  name: ReactNode,
  visible?: boolean,
  isSorted?: boolean,
  disabledSortBy?: boolean,
  toggleSorting?: () => void;
  toggleColumnVisibility?: object[];
}

const ColumnItem = memo<ListItemProps>(({ sorting, disabledSortBy, name, isSorted, visible, toggleColumnVisibility, toggleSorting }) => {
  return (
    <div className={styles.root}>
      <div className={styles.textStyle}>
        {name}
      </div>
      {
        !disabledSortBy &&
        <button
          type="button"
          className={classnames({
            [styles.sortingButton]: true,
            [styles.sortingButtonActive]: isSorted,
          })}
          onClick={toggleSorting}
        >
          {sorting ?
            <ArrowDownIcon /> :
            <ArrowUpIcon />}
        </button>
      }
      <CheckBoxIcon
        key={name?.toString()}
        label={name?.toString()}
        visible={visible}
        {...toggleColumnVisibility}
      />
    </div>
  );
});

export default ColumnItem;
